webpackJsonp([52739766585696],{

/***/ 880:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 740:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(["\n  mutation Login($email: String!, $password: String!) {\n    info: authenticateUser(email: $email, password: $password) {\n      token\n    }\n  }\n"], ["\n  mutation Login($email: String!, $password: String!) {\n    info: authenticateUser(email: $email, password: $password) {\n      token\n    }\n  }\n"]),
	    _templateObject2 = _taggedTemplateLiteralLoose(["\n  query loginQuery {\n    user: loggedInUser {\n      id\n    }\n  }\n"], ["\n  query loginQuery {\n    user: loggedInUser {\n      id\n    }\n  }\n"]);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _semanticUiReact = __webpack_require__(20);
	
	var _gatsbyLink = __webpack_require__(58);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _reactApollo = __webpack_require__(59);
	
	__webpack_require__(880);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var LoginComponent = function (_Component) {
	  _inherits(LoginComponent, _Component);
	
	  function LoginComponent() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, LoginComponent);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = { email: "", password: "" }, _this.componentDidMount = function () {
	      if (!_this.props.loading && _this.props.user) {
	        (0, _gatsbyLink.navigateTo)("/");
	      }
	    }, _this.componentDidUpdate = function () {
	      if (!_this.props.data.loading && _this.props.data.user) {
	        (0, _gatsbyLink.navigateTo)("/");
	      }
	    }, _this.handleChange = function (e, _ref) {
	      var _this$setState;
	
	      var name = _ref.name,
	          value = _ref.value;
	      return _this.setState((_this$setState = {}, _this$setState[name] = value, _this$setState));
	    }, _this.handleSubmit = function () {
	      var _this$state = _this.state,
	          email = _this$state.email,
	          password = _this$state.password;
	
	
	      _this.props.mutate({
	        variables: {
	          email: email,
	          password: password
	        }
	      }).then(function (_ref2) {
	        var data = _ref2.data;
	
	        localStorage.setItem("gToken", data.info.token);
	        _this.props.history.push("/booking");
	      }).catch(function (err) {
	        return console.error(err);
	      });
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  LoginComponent.prototype.render = function render() {
	    console.log(this.props);
	    var _state = this.state,
	        password = _state.password,
	        email = _state.email;
	
	    return _react2.default.createElement(
	      "div",
	      { className: "login-gradient" },
	      _react2.default.createElement(
	        _semanticUiReact.Container,
	        { style: { paddingTop: "15vw", textAlign: "center" } },
	        _react2.default.createElement(
	          _semanticUiReact.Segment,
	          { raised: true, style: { maxWidth: "500px", margin: "0 auto" } },
	          _react2.default.createElement(
	            "h1",
	            null,
	            "Please login to view your scheduled cleans or schedule a new cleaning."
	          ),
	          _react2.default.createElement(
	            _semanticUiReact.Form,
	            { onSubmit: this.handleSubmit },
	            _react2.default.createElement(_semanticUiReact.Form.Input, {
	              placeholder: "Email",
	              name: "email",
	              value: email,
	              onChange: this.handleChange
	            }),
	            _react2.default.createElement(_semanticUiReact.Form.Input, {
	              placeholder: "Password",
	              name: "password",
	              value: password,
	              onChange: this.handleChange,
	              type: "password"
	            }),
	            _react2.default.createElement(_semanticUiReact.Form.Button, { fluid: true, content: "Submit" }),
	            _react2.default.createElement(
	              _gatsbyLink2.default,
	              { to: "/booking" },
	              _react2.default.createElement(
	                _semanticUiReact.Button,
	                { fluid: true, negative: true },
	                "Cancel",
	                " "
	              )
	            )
	          )
	        )
	      )
	    );
	  };
	
	  return LoginComponent;
	}(_react.Component);
	
	var myMutation = (0, _reactApollo.gql)(_templateObject);
	var myQuery = (0, _reactApollo.gql)(_templateObject2);
	
	exports.default = (0, _reactApollo.compose)((0, _reactApollo.graphql)(myQuery, {
	  options: {
	    fetchPolicy: "cache-and-network"
	  }
	}), (0, _reactApollo.graphql)(myMutation))(LoginComponent);
	module.exports = exports["default"];

/***/ }),

/***/ 757:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Login = __webpack_require__(740);
	
	var _Login2 = _interopRequireDefault(_Login);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Login = function (_Component) {
	  _inherits(Login, _Component);
	
	  function Login() {
	    _classCallCheck(this, Login);
	
	    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  Login.prototype.render = function render() {
	    return _react2.default.createElement(
	      "div",
	      null,
	      _react2.default.createElement(_Login2.default, { history: this.props.history })
	    );
	  };
	
	  return Login;
	}(_react.Component);
	
	exports.default = Login;
	module.exports = exports["default"];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-login-jsx-3513cdd985dffcf1614b.js